import React from 'react';

const AppImage = ({ alt, priority = false, loading, decoding = 'async', fetchpriority, ...props }) => {
    const resolvedLoading = loading || (priority ? 'eager' : 'lazy');
    const resolvedFetchPriority = fetchpriority || (priority ? 'high' : 'auto');

    return (
        <img
            {...props}
            alt={alt}
            loading={resolvedLoading}
            decoding={decoding}
            fetchpriority={resolvedFetchPriority}
        />
    );
};

export default AppImage;
